import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelectAsync from '../ReactSelectAsync/ReactSelectAsync';

/*
 Example of details that would be passed in:

 */
export default class WorkLocationInput extends Component {
  static propTypes = {
    borderColor: PropTypes.string,
    workLocationExact: PropTypes.string,
    disabled: PropTypes.bool,
    search: PropTypes.func,
    onChange: PropTypes.func,
    fnClear: PropTypes.func,
    pageSpecificClasses: PropTypes.string
  };

  constructor(props) {
    super(props);

    if (this.props.workLocationExact) {
      this.state = {
        workLocation: this.props.workLocationExact,
        workLocationValue: this.props.workLocationExact,
        locationValidationColor: '#ccc',
        options: [
          {
            value: this.props.workLocationExact,
            label: this.props.workLocationExact
          }
        ]
      };
    } else {
      this.state = {
        workLocation: '',
        workLocationValue: '',
        locationValidationColor: '#ccc',
        options: [
          {
            value: '',
            label: ''
          }
        ]
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.workLocationExact !== prevProps.workLocationExact) {
      this.setState({
        workLocation: this.props.workLocationExact,
        workLocationValue: this.props.workLocationExact,
        locationValidationColor: '#ccc',
        options: [
          {
            value: this.props.workLocationExact,
            label: this.props.workLocationExact
          }
        ]
      });
    }
  }

  loadWorkLocationOptions(input, callback) {
    if (input && input.length >= 2) {
      this.props.search({
        params: {
          workLocation: input
        },
        searchCallback: callback
      });
    } else {
      callback([]);
    }
  }

  handleWorkLocationChange(event) {
    if (event) {
      this.setState({ workLocationValue: event.value });
      this.setState({ workLocation: event.label });

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    } else {
      this.setState({ workLocationValue: '' });
      this.setState({ workLocation: '' });

      if (this.props.onChange) {
        this.props.onChange('');
      }

      // Called when clicking the x button. Clear out the db value by sending empty string.
      if (this.props.fnClear) {
        this.props.fnClear();
      }
    }
  }

  render() {
    let classes = '';
    if (this.props.pageSpecificClasses) {
      classes = this.props.pageSpecificClasses;
    }

    let value = null;
    if (this.state.workLocation) {
      value = { label: this.state.workLocation, value: this.state.workLocation };
    }

    return (
      <div className={classes}>
        <ReactSelectAsync
          className={'add-job__search-job__input input__form--workLocation' + classes}
          styles={{ control: styles => ({ ...styles, borderColor: this.props.borderColor }) }}
          value={value}
          placeholder={'Search for location'}
          isDisabled={this.props.disabled}
          onChange={this.handleWorkLocationChange.bind(this)}
          loadOptions={this.loadWorkLocationOptions.bind(this)}
          noOptionsMessage={() => 'Type to Search'}
        />
      </div>
    );
  }
}
